var fvChannel = require('glRadio').channel('FV'),
    Group = require('./groupModel.js'),
    Backbone = require('backbone');

/**
 * Base Group Model -- no url.
 */

module.exports = Backbone.Collection.extend({

    model: Group,

    initialize: function() {

        this.aModelAttrsSortedByName = null; // set at first request ( if utilized )

        this.groupOfDerivedUserColor = null; // set at first request ( if utilized; could be null if there are no groups )
        this.groupOfDerviedUserColorSet = false; // ( b/c above can be null )

    },

    // returns array of objects containing model attributes by name
    // used to populate the accessible select box in the note view
    getArrayOfModelAttrsSortedByName: function() {

        if (this.aModelAttrsSortedByName)
            return this.aModelAttrsSortedByName;

        this.aModelAttrsSortedByName = this.chain()
            .map( function(g) {
                return g.toJSON();
            })
            .sortBy( function(i) {
                return i.name.toLowerCase();
            } )
            .value();

        return this.aModelAttrsSortedByName;

    },

    getUserInfoGroupIds: function() {
        return this.pluck('groupId');
    },


    /* also sets with caching on first request: but it could be null, *F* */
    getGroupOfDerivedUserColor: function() {

        if ( this.groupOfDerviedUserColorSet && this.groupOfDerivedUserColor ) {
            return this.groupOfDerivedUserColor;
        }

        this.groupOfDerivedUserColor = this._generateGroupOfDerivedUserColor();

        return this.groupOfDerivedUserColor;

    },

    _generateGroupOfDerivedUserColor: function() {


        this.groupOfDerviedUserColorSet = true; // ( only called once )

        if ( this.length < 1 )
            return null;

        var groupsWithColorsAssigned = this.filter( function( group ) {
            var color = group.get('color');
            return color && color !== null;
        });

        if ( groupsWithColorsAssigned.length !== 1 )
            return null;

        return groupsWithColorsAssigned[0];

    },

    getDerivedUserGroupColor: function() {

        return this.getGroupOfDerivedUserColor().getColor();

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/groups/groupCollection.js
 ** module id = 85
 ** module chunks = 0
 **/